import i18n from '@/i18n.json';

const { defaultLocale, locales } = i18n;

/** Splits `/fr/networks/x` into `{ locale: 'fr', path: '/networks/x' }`. */
export const splitLocale = (pathname = '/') => {
  const clean = `/${pathname.split(/[?#]/)[0].replace(/^\/+/, '')}`;
  const [, first = '', ...rest] = clean.split('/');

  if (first !== defaultLocale && locales.includes(first)) {
    return { locale: first, path: `/${rest.join('/')}` };
  }

  return { locale: defaultLocale, path: clean };
};

const withLocale = (path, locale) => {
  const trimmed = path.replace(/\/+$/, '');
  if (locale === defaultLocale) return trimmed || '/';
  return `/${locale}${trimmed}`;
};

/** The home page of a locale: `/` for the default locale, `/fr` otherwise. */
export const localeRoot = (locale) => withLocale('/', locale);

/**
 * The same page in another locale. No route has translated URL segments, so
 * only the locale prefix changes.
 *
 *   localizePath('/es/networks/solana', 'de')  // '/de/networks/solana'
 *   localizePath('/fr/countries', 'en')        // '/countries'
 */
export const localizePath = (pathname, toLocale) =>
  withLocale(splitLocale(pathname).path, toLocale);

/** Browser only: the URL of the current page (query string kept) in `toLocale`. */
export const currentPathInLocale = (toLocale) => {
  if (typeof window === 'undefined') return localeRoot(toLocale);
  return `${localizePath(window.location.pathname, toLocale)}${window.location.search}`;
};
